import classroomImage1 from '../../styles/default/classrooms/classroom_01.png';
import classroomImage2 from '../../styles/default/classrooms/classroom_02.png';
import classroomImage3 from '../../styles/default/classrooms/classroom_03.png';
import classroomImage4 from '../../styles/default/classrooms/classroom_04.png';
import classroomImage5 from '../../styles/default/classrooms/classroom_05.png';
import classroomImage6 from '../../styles/default/classrooms/classroom_06.png';
import classroomImage7 from '../../styles/default/classrooms/classroom_07.png';
import classroomImage8 from '../../styles/default/classrooms/classroom_08.png';
import classroomImage9 from '../../styles/default/classrooms/classroom_09.png';
import classroomImage10 from '../../styles/default/classrooms/classroom_10.png';

import avatarImage1 from '../../styles/default/avatars/avatar_01.png';
import avatarImage2 from '../../styles/default/avatars/avatar_02.png';
import avatarImage3 from '../../styles/default/avatars/avatar_03.png';
import avatarImage4 from '../../styles/default/avatars/avatar_04.png';
import avatarImage5 from '../../styles/default/avatars/avatar_05.png';
import avatarImage6 from '../../styles/default/avatars/avatar_06.png';
import avatarImage7 from '../../styles/default/avatars/avatar_07.png';
import avatarImage8 from '../../styles/default/avatars/avatar_08.png';
import avatarImage9 from '../../styles/default/avatars/avatar_09.png';
import avatarImage10 from '../../styles/default/avatars/avatar_10.png';
import avatarImage11 from '../../styles/default/avatars/avatar_11.png';
import avatarImage12 from '../../styles/default/avatars/avatar_12.png';
import avatarImage13 from '../../styles/default/avatars/avatar_13.png';
import avatarImage14 from '../../styles/default/avatars/avatar_14.png';
import avatarImage15 from '../../styles/default/avatars/avatar_15.png';
import avatarImage16 from '../../styles/default/avatars/avatar_16.png';
import avatarImage17 from '../../styles/default/avatars/avatar_17.png';
import avatarImage18 from '../../styles/default/avatars/avatar_18.png';
import avatarImage19 from '../../styles/default/avatars/avatar_19.png';
import avatarImage20 from '../../styles/default/avatars/avatar_20.png';
import avatarImage21 from '../../styles/default/avatars/avatar_21.png';
import avatarImage22 from '../../styles/default/avatars/avatar_22.png';
import avatarImage23 from '../../styles/default/avatars/avatar_23.png';
import avatarImage24 from '../../styles/default/avatars/avatar_24.png';

import splashImage from '../../styles/default/splash_screen.png';
import menuHeader from '../../styles/default/headers/header_menu.png';
import bookHeader from '../../styles/default/headers/header_book.png';

import placeholderLessonDEFAULT from '../../styles/default/placeholders/lesson/default.svg';
import placeholderLessonCSV from '../../styles/default/placeholders/lesson/csv.svg';
import placeholderLessonGIF from '../../styles/default/placeholders/lesson/gif.svg';
import placeholderLessonJPG from '../../styles/default/placeholders/lesson/jpg.svg';
import placeholderLessonPNG from '../../styles/default/placeholders/lesson/png.svg';
import placeholderLessonDOC from '../../styles/default/placeholders/lesson/doc.svg';
import placeholderLessonLINK from '../../styles/default/placeholders/lesson/link.svg';
import placeholderLessonODP from '../../styles/default/placeholders/lesson/odp.svg';
import placeholderLessonODS from '../../styles/default/placeholders/lesson/ods.svg';
import placeholderLessonODT from '../../styles/default/placeholders/lesson/odt.svg';
import placeholderLessonPDF from '../../styles/default/placeholders/lesson/pdf.svg';
import placeholderLessonPPT from '../../styles/default/placeholders/lesson/ppt.svg';
import placeholderLessonPPTX from '../../styles/default/placeholders/lesson/pptx.svg';
import placeholderLessonXLS from '../../styles/default/placeholders/lesson/xls.svg';

import taskImageGroup from '../../styles/default/placeholders/task/TaskImageGroup.svg';
import taskImageIndividual from '../../styles/default/placeholders/task/TaskImageIndividual.svg';

import placeholderBook from '../../styles/default/placeholders/placeholder_book.svg';
import emptyMonster from '../../styles/default/placeholders/placeholder_empty.png';
import csvIcon from '../../styles/default/placeholders/placeholder_csv.svg';
import attachmentIcon from '../../styles/default/placeholders/attachment_icon.svg';
import placeholderEmptyClassroom from '../../styles/default/placeholders/placeholder_empty_classroom.png';
import authoringNotification from '../../styles/default/placeholders/authoring_notification.svg';

import logoSmall from '../../styles/default/logos/small.png';
import logoBigLight from '../../styles/default/logos/big_light.png';
import logoBigDark from '../../styles/default/logos/big_dark.png';
import successMonster from '../../styles/default/icons/success.png';
import warningMonster from '../../styles/default/icons/warning.png';
import failMonster from '../../styles/default/icons/error.png';
import groupMonsterColor from '../../styles/default/icons/group_color.png';
import groupMonsterBg from '../../styles/default/icons/group_bg.png';
import individualMonsterColor from '../../styles/default/icons/individual_color.png';
import individualMonsterBg from '../../styles/default/icons/individual_bg.png';
import reconnect from '../../styles/default/icons/reconnect.svg';

import favicon from '../../images/icon.ico';

import emojiAcceptableActive from '../../styles/default/emojis/acceptable_active.svg';
import emojiAcceptableInactive from '../../styles/default/emojis/acceptable_inactive.svg';
import emojiExcellentActive from '../../styles/default/emojis/excellent_active.svg';
import emojiExcellentInactive from '../../styles/default/emojis/excellent_inactive.svg';
import emojiGoodActive from '../../styles/default/emojis/good_active.svg';
import emojiGoodInactive from '../../styles/default/emojis/good_inactive.svg';
import emojiPoorActive from '../../styles/default/emojis/poor_active.svg';
import emojiPoorInactive from '../../styles/default/emojis/poor_inactive.svg';
import emojiVeryPoorActive from '../../styles/default/emojis/verypoor_active.svg';
import emojiVeryPoorInactive from '../../styles/default/emojis/verypoor_inactive.svg';
import emojiPending from '../../styles/default/emojis/pending.svg';

import colors from '../../styles/default/colors';
import layout from '../../styles/default/layout';

let skinTemplate = {
  colors: colors,
  images: {
    icons: {
      alertSuccess: successMonster,
      alertError: failMonster,
      alertWarning: warningMonster,
      groupColor: groupMonsterColor,
      groupBg: groupMonsterBg,
      individualBg: individualMonsterBg,
      individualColor: individualMonsterColor,
      reconnect: reconnect
    },
    splashScreen: splashImage,
    headers: {
      menu: menuHeader,
      book: bookHeader
    },
    logos: {
      favicon: favicon,
      bigLight: logoBigLight,
      bigDark: logoBigDark,
      small: logoSmall
    },
    avatars: {
      1: avatarImage1,
      2: avatarImage2,
      3: avatarImage3,
      4: avatarImage4,
      5: avatarImage5,
      6: avatarImage6,
      7: avatarImage7,
      8: avatarImage8,
      9: avatarImage9,
      10: avatarImage10,
      11: avatarImage11,
      12: avatarImage12,
      13: avatarImage13,
      14: avatarImage14,
      15: avatarImage15,
      16: avatarImage16,
      17: avatarImage17,
      18: avatarImage18,
      19: avatarImage19,
      20: avatarImage20,
      21: avatarImage21,
      22: avatarImage22,
      23: avatarImage23,
      24: avatarImage24
    },
    classrooms: {
      1: classroomImage1,
      2: classroomImage2,
      3: classroomImage3,
      4: classroomImage4,
      5: classroomImage5,
      6: classroomImage6,
      7: classroomImage7,
      8: classroomImage8,
      9: classroomImage9,
      10: classroomImage10
    },
    placeholders: {
      emptyClassrooms: placeholderEmptyClassroom,
      book: placeholderBook,
      empty: emptyMonster,
      csvIcon: csvIcon,
      attachmentIcon: attachmentIcon,
      authoringNotification: authoringNotification,
      lesson: {
        default: placeholderLessonDEFAULT,
        'text/csv': placeholderLessonCSV,
        'application/msword': placeholderLessonDOC,
        'image/gif': placeholderLessonGIF,
        'image/jpeg': placeholderLessonJPG,
        'web/resource': placeholderLessonLINK,
        'application/vnd.oasis.opendocument.presentation': placeholderLessonODP,
        'application/vnd.oasis.opendocument.spreadsheet': placeholderLessonODS,
        'application/vnd.oasis.opendocument.text': placeholderLessonODT,
        'application/pdf': placeholderLessonPDF,
        'image/png': placeholderLessonPNG,
        'application/vnd.ms-powerpoint': placeholderLessonPPT,
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': placeholderLessonPPTX,
        'application/vnd.ms-excel': placeholderLessonXLS
      },
      task: {
        taskImageGroup: taskImageGroup,
        taskImageIndividual: taskImageIndividual
      }
    },
    emojis: {
      emojiAcceptableActive,
      emojiAcceptableInactive,
      emojiExcellentActive,
      emojiExcellentInactive,
      emojiGoodActive,
      emojiGoodInactive,
      emojiPoorActive,
      emojiPoorInactive,
      emojiVeryPoorActive,
      emojiVeryPoorInactive,
      emojiPending
    }
  },
  layoutSettings: layout
};

export default skinTemplate;
